// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .margen-inferior {\n  margin-bottom: 15px;\n}\n.container-data {\n  max-height: 70vh !important;\n  height: 70vh;\n  overflow: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
